import * as React from "react";
const SvgFiRrTents = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tents_svg__a)">
      <path
        fill="#062147"
        d="M13.78 9.31C12.67 7.756 11.433 7 9.998 7c-1.67 0-2.521.845-3.724 2.237-.026.03-5.85 8.65-5.873 8.698a4.24 4.24 0 0 0 .271 4.09A4.26 4.26 0 0 0 4.275 24h11.448a4.25 4.25 0 0 0 3.603-1.975 4.24 4.24 0 0 0 .271-4.09c-.022-.048-5.819-8.625-5.819-8.625zM7.524 22l2.001-3.698A.51.51 0 0 1 9.999 18c.1 0 .348.029.501.356L12.474 22H7.523zm10.117-1.05A2.24 2.24 0 0 1 15.724 22h-.974l-2.464-4.542A2.5 2.5 0 0 0 9.998 16c-.993 0-1.87.559-2.26 1.403L5.249 22h-.974a2.24 2.24 0 0 1-1.917-1.05 2.22 2.22 0 0 1-.174-2.104l5.64-8.345c1.147-1.323 1.481-1.5 2.173-1.5.514 0 1.222.167 2.14 1.451l5.677 8.395a2.22 2.22 0 0 1-.174 2.104zm4.402-4.63a1 1 0 0 1-1.086-1.68c.81-.523 1.354-1.644.858-2.794l-5.677-8.395C15.221 2.167 14.512 2 13.998 2c-.692 0-1.025.178-2.173 1.5l-.716 1.06a1 1 0 0 1-1.658-1.12s.796-1.173.822-1.203C11.476.845 12.327 0 13.997 0c1.435 0 2.672.756 3.782 2.31 0 0 5.796 8.578 5.819 8.625a4.29 4.29 0 0 1-1.555 5.385"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tents_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTents;
